import { useQuery } from '@tanstack/react-query';
import { IAICampaignGenerationJob, TERMINAL_AI_CAMPAIGN_STATUSES } from '../../models/AICampaign';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { reactQueryClient } from '../../web/ReactQueryProvider';

const BASE_QUERY_KEY = 'aiCampaign/generation';

/** A run over a large audience takes minutes, so this is about keeping the progress bar honest, not about latency. */
const PollIntervalMs = 5000;

export function useAICampaignGenerationJob({ jobId, enabled = true }: { jobId: string; enabled?: boolean }) {
	const userSession = useUserSession();
	return useQuery({
		enabled: enabled && !!jobId,
		queryFn: async () => {
			return userSession.webServiceHelper.callAsync<IAICampaignGenerationJob>(
				`AICampaign/generation/${encodeURIComponent(jobId)}`,
				'GET'
			);
		},
		queryKey: [BASE_QUERY_KEY, jobId],
		// Polling belongs to the query, not the component: it stops on its own once the run reaches a terminal
		// status, where an interval driven from a rendering component would keep firing.
		refetchInterval: query =>
			TERMINAL_AI_CAMPAIGN_STATUSES.includes(query.state.data?.status) ? false : PollIntervalMs,
		meta: {
			toastErrorMessage: 'Failed to load generation progress',
		},
	});
}

export const invalidateAICampaignGenerationJob = (jobId: string) => {
	reactQueryClient.invalidateQueries({ queryKey: [BASE_QUERY_KEY, jobId] });
};
